import { useTranslate } from "@refinedev/core";
import { Toggle } from "@libertify/ui";
import { Flex, Typography } from "antd";
import { useTemplateEditorStore } from "../../../../store/useTemplateEditorStore";
import { useTemplatesStatusStore } from "../../../../store/useTemplatesStatusStore";
import { TemplateType } from "../../../../types";
import { useSceneVideoSound } from "../../../../hooks/useSceneVideoSound";

export const PlayVideoSoundFeature = () => {
  const t = useTranslate();

  const { currentChapter, templateState, setIntro, setClosing } =
    useTemplateEditorStore((store) => ({
      currentChapter: store.currentChapter,
      templateState: store.templateState,
      setIntro: store.setIntro,
      setClosing: store.setClosing,
    }));

  const { addTemplateUpdate } = useTemplatesStatusStore((state) => ({
    addTemplateUpdate: state.addTemplateUpdate,
  }));

  const isIntro = currentChapter.type === TemplateType.INTRODUCTION;
  const scene = isIntro ? templateState.intro : templateState.closing;
  const setter = isIntro ? setIntro : setClosing;

  const { hasAudio, canPlaySound } = useSceneVideoSound(scene);
  const isStoredOn = !!scene.playVideoSound;

  const handleChange = (checked: boolean) => {
    setter({ playVideoSound: checked });
    addTemplateUpdate();
  };

  return (
    <Flex vertical gap={8}>
      <Flex align="center" gap={8}>
        <Typography.Text id="play-video-sound-label">
          {t("components.templates.settings.layoutTab.videoSound.title")}
        </Typography.Text>
        <Toggle
          checked={isStoredOn}
          // A stored "on" stays switchable so old templates can turn it off
          disabled={!canPlaySound && !isStoredOn}
          onChange={handleChange}
          aria-labelledby="play-video-sound-label"
          aria-describedby={
            canPlaySound ? undefined : "play-video-sound-reason"
          }
        />
      </Flex>
      {canPlaySound ? null : (
        <Typography.Text type="secondary" id="play-video-sound-reason">
          {hasAudio === false
            ? t("components.templates.settings.layoutTab.videoSound.noSound")
            : t(
                "components.templates.settings.layoutTab.videoSound.processing"
              )}
        </Typography.Text>
      )}
    </Flex>
  );
};
